import { Menu, MenuItem } from '@material-ui/core';
import Favo from 'assets/icons/favo';
import KeyboardArrowDownIcon from 'components/Icons/KeyboardArrowDownIcon';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import { Fragment, useContext, useMemo, useRef, useState } from 'react';
import { getMergedClassNames } from 'utils/HTMLUtils';
import languageValues from 'utils/LanguageUtils';
import { getUniqueKey } from 'utils/NumberUtils';
import { getStatusStep } from '../../stepSidebar/stepSidebar';
import styles from './menuEtapas.scss';
const { rootClassName } = styles;

interface Props {
  children: JSX.Element;
}

const language = languageValues.pages.projetos.etapas;
export default function MenuEtapas(props: Props) {
  const [opened, setOpened] = useState(false);
  const idRef = useMemo(getUniqueKey, []);
  const buttonRef = useRef<any>(document.getElementById(idRef));

  const { state, validator, changeEtapa } = useContext(ProjetosContext);

  return (
    <Fragment>
      <button
        id={idRef}
        className={rootClassName}
        onClick={() => {
          if (window.innerWidth < 768) {
            buttonRef.current = document.getElementById(idRef);
            setOpened(!opened);
          }
        }}
      >
        <div
          className={getMergedClassNames([
            `${rootClassName}-arrow`,
            opened ? `${rootClassName}-arrow-opened` : '',
          ])}
        >
          <KeyboardArrowDownIcon />
        </div>
        {props.children}
      </button>
      <Menu
        PaperProps={{
          style: { width: 'calc(100% - 30px)', transform: 'translateY(48px)' },
        }}
        open={opened}
        onClose={() => {
          setOpened(false);
        }}
        anchorEl={buttonRef.current}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        {Object.values(EtapaProjeto).map((etapa) => {
          const name = language[etapa].name;

          return (
            <MenuItem
              disabled={validator?.etapaIsDisabled[etapa]}
              key={etapa}
              className={getMergedClassNames([
                `${rootClassName}-item`,
                `status-${getStatusStep(etapa, state.projeto.avaliacoes)}`,
              ])}
              onClick={() => {
                setOpened(false);
                changeEtapa(etapa);
              }}
            >
              <Favo style={{ minWidth: '18px' }} />
              {typeof name === 'function'
                ? name(state.projeto.flgInfantil)
                : name}
            </MenuItem>
          );
        })}
      </Menu>
    </Fragment>
  );
}
